import { DateField, Show, Tab, TabbedShowLayout, TextField } from "react-admin"

export const GuestView = () => (
  <Show>
    <TabbedShowLayout spacing={2}>
      <Tab label="Guest Details">
        <TextField source="first_name" />
        <TextField source="last_name" />
        <TextField source="id_card_number" />
        <DateField source="attended_from" />
        <DateField source="attended_to" />
        <DateField source="birth_date" />
        <TextField source="email" />
        <TextField source="phone" />
        <TextField source="internal_notes" />
      </Tab>

      <Tab label="Meta">
        <TextField source="id" />
        <TextField source="guest_template_id" />
        <DateField source="created_at" showTime />
        <DateField source="updated_at" showTime />
        <TextField source="created_by" />
      </Tab>
    </TabbedShowLayout>
  </Show>
)
